import Operational from ".";

export const operationalRoutes = [
  {
    path: "/operational",
    element: <Operational />,
  },
];
